module.exports = __webpack_public_path__ + "img/item2.1e77f6b0.png";